module.exports = __webpack_public_path__ + "img/icon-no-tasks.901efc7a.svg";